<template>
  <div
    v-if="isModuleEnabled"
    class="c-visualhighlight__wrapper"
    :class="{
      '-centered': centered,
      '-centered@tabletPortrait': !onlyRectangle && advertisement.leaderboard_image_url,
      '-desktopRow': desktopRow,
    }"
    data-cy="AdCard">
    <div
      v-if="advertisement.is_ad || advertisement.rectangle_image_url"
      class="c-visualhighlight"
      :class="{
        '-textOnly': !advertisement.rectangle_image_url && advertisement.description,
      }">
      <div
        v-if="advertisement.is_ad"
        class="c-visualhighlight__infotext">
        {{ $t('generic.ad') }}
      </div>
      <component
        :is="wrapperTag"
        v-if="advertisement.rectangle_image_url"
        class="c-visualhighlight__image"
        v-bind="wrapperAttributes">
        <picture>
          <source
            v-if="!onlyRectangle && advertisement.leaderboard_image_url"
            media="(min-width: 768px)"
            :srcset="advertisement.leaderboard_image_url" />
          <img
            :src="advertisement.rectangle_image_url"
            data-cy="AdCard__image"
            alt="Advertisement" />
        </picture>
      </component>
    </div>
    <div
      v-if="advertisement.description"
      class="c-visualhighlight__text c-card -fullWidth">
      <div
        v-internallinks
        class="c-card__content o-textbody"
        v-html="advertisement.description" />
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'

import store from '@/store'

const props = defineProps({
  advertisement: {
    required: true,
    type: Object,
  },
  onlyRectangle: {
    required: false,
    type: Boolean,
    default: false,
  },
  centered: {
    required: false,
    type: Boolean,
    default: false,
  },
  desktopRow: {
    required: false,
    type: Boolean,
    default: false,
  },
})

const isModuleEnabled = computed(() => store.getters['auth/hasModule'].advertisements)

const isInternalLink = computed(() => {
  if (!props.advertisement.link) {
    return false
  }

  const targetUrl = new URL(props.advertisement.link)
  if (store.getters['auth/config'].app_domains.includes(targetUrl.host)) {
    return true
  }

  return false
})

const wrapperTag = computed(() => {
  if (props.advertisement.link) {
    if (isInternalLink.value) {
      return 'router-link'
    }
    return 'a'
  }
  return 'div'
})

const wrapperAttributes = computed(() => {
  if (!props.advertisement.link) {
    return {}
  }
  if (isInternalLink.value) {
    const pathOnly = props.advertisement.link.replace(/^https?:\/\/[^/]+/, '') || '/'
    return {
      to: pathOnly,
    }
  }
  return {
    href: props.advertisement.link,
    target: '_blank',
    rel: 'noopener',
  }
})
</script>
